import React, { FC, useMemo } from 'react';
import { Grid, Header2Text } from '../../../../../ui-toolkit/components';
import { useHasPermissions } from '../../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from '../../../../../types/administration/userAdministration/ePermissions';
import { convertExpectedIncomingAchTableQueryToApiQuery } from '../../../../../types/accounting/query/IEscrowExpectedIncomingAchQuery';
import { StyledDisbursedContainer } from '../../shared/StyledDisbursedContainer';
import { generateAchPullDepositTableColumns } from './generateAchPullDepositTableColumns';
import { useGetACHIncomingExpectedQuery } from 'API/accounting/AccountingApi';

export const AchDepositsContainer: FC<{ escrowFileId: string }> = ({ escrowFileId }) => {
  const hasReadPermissions = useHasPermissions([
    ePermissions.EscrowExpectedAchPullDepositsRead,
    ePermissions.EscrowActualAchDepositsRead,
  ]);

  const query = useMemo(() => {
    return convertExpectedIncomingAchTableQueryToApiQuery({
      escrowFileId,
    });
  }, [escrowFileId]);

  const { data, isFetching } = useGetACHIncomingExpectedQuery(query, { skip: !hasReadPermissions });

  return (
    <Grid>
      <Header2Text>ACH Deposits</Header2Text>
      <StyledDisbursedContainer
        columns={generateAchPullDepositTableColumns()}
        keyField="id"
        data={data?.content ?? []}
        loading={isFetching}
      />
    </Grid>
  );
};
